module.exports = __webpack_public_path__ + "static/img/loading.af71cfd.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/loading.gif
// module id = 4
// module chunks = 3